import './app/react/legacy-sync-setstate';
import React from 'react';
import { createRoot } from 'react-dom/client';
import JSZip from 'jszip';
window.JSZip = JSZip;
import '@progress/kendo-ui';
import '@progress/kendo-ui/kendo.aspnetmvc.ready.js';
import '@progress/kendo-ui/kendo.aspnetmvc.js';
import './index.scss';
import App from './app/react/index';
import ErrorBoundary from './app/react/ErrorBoundary';

if (!window.kendo.support.kineticScrollNeeded) {
  window.kendo.support.kineticScrollNeeded =
    /iPad|iPhone|iPod|Linux i686|Android/.test(navigator.platform) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

window.param_roleType = 'Customer';
window.getTreeViewTemplate = (data) => {
  if (data.param_roleType) {
    window.param_roleType = data.param_roleType;
  }

  if (window.param_roleType === 'Customer' && data.scope === 2) {
    return `<span class="redText"> ${data.text}</span>`;
  }

  return data.text;
};

const root = createRoot(document.getElementById('root'));

root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
